<template>
  <div>
    <!-- <hom-header></hom-header> -->
    <category-view></category-view>
    <procure-view></procure-view>
    <supply-view></supply-view>
    <consult-view></consult-view>
    <hot-view></hot-view>

    <!-- <CanvasPage :terminal="4" :typeId="1"></CanvasPage> -->
  </div>
</template>

<script>
  import CanvasPage from '@/components/canvasShow/canvasShowPage'
  import HomHeader from '@/components/base/homHeader'
  import CategoryView from '@/components/home/category' // 类目
  import ProcureView from '@/components/home/procure' // 今日采购
  import SupplyView from '@/components/home/supply' // 热门供应
  import ConsultView from '@/components/home/consult' // 行业资讯
  import HotView from '@/components/home/hot' // 热门供应

  export default {
    name: 'index',
    components: { HomHeader, CategoryView, ProcureView, SupplyView, ConsultView, HotView, CanvasPage },
    data () {
      return {
        canvasData: []
      }
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/home/index.vue